import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_PART_STOCKS](state, data) {
    state.allPartStocks = data
  },
}
